import React, { useState, useEffect, useRef } from 'react';
import firebase from './firebase';
import '../styles/chatadmin.css';

export const ChatAdmin = () => {
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // Font Awesome се ползва само тук (двете иконки долу). Зареждаше се в
  // public/index.html на всяка страница и забавяше първото изрисуване за
  // клиентите с ~1.3 s на мобилни данни, затова се добавя само в тази страница.
  useEffect(() => {
    const id = 'font-awesome-css';
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css';
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Load all chats
  useEffect(() => {
    const db = firebase.firestore();
    const unsubscribe = db
      .collection('chats')
      .orderBy('createdAt', 'desc')
      .onSnapshot((snapshot) => {
        const chatsData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setChats(chatsData);
      });

    return () => unsubscribe();
  }, []);

  // Load messages for selected chat
  useEffect(() => {
    if (selectedChat) {
      const db = firebase.firestore();
      const unsubscribe = db
        .collection('chats')
        .doc(selectedChat.id)
        .collection('messages')
        .orderBy('timestamp', 'asc')
        .onSnapshot((snapshot) => {
          const msgs = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setMessages(msgs);
        });

      // Mark messages as read
      db.collection('chats').doc(selectedChat.id).update({
        unreadByAdmin: 0
      });

      return () => unsubscribe();
    }
  }, [selectedChat]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    
    if (!newMessage.trim() || !selectedChat) return;

    try {
      const db = firebase.firestore();
      
      await db.collection('chats').doc(selectedChat.id).collection('messages').add({
        text: newMessage,
        sender: 'admin',
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        read: false
      });

      await db.collection('chats').doc(selectedChat.id).update({
        lastMessage: newMessage,
        lastMessageTime: firebase.firestore.FieldValue.serverTimestamp()
      });

      setNewMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <div className="chat-admin-container">
      <div className="chat-admin-header">
        <h2>💬 Chat Admin Panel</h2>
        <p>Управление на съобщения от клиенти</p>
      </div>

      <div className="chat-admin-content">
        {/* Chat List */}
        <div className="chat-list">
          <h3>Активни чатове ({chats.length})</h3>
          {chats.length === 0 ? (
            <p className="no-chats">Няма активни чатове</p>
          ) : (
            chats.map((chat) => (
              <div
                key={chat.id}
                className={`chat-item ${selectedChat?.id === chat.id ? 'active' : ''}`}
                onClick={() => setSelectedChat(chat)}
              >
                <div className="chat-item-header">
                  <strong>{chat.customerName}</strong>
                  {chat.unreadByAdmin > 0 && (
                    <span className="unread-badge">{chat.unreadByAdmin}</span>
                  )}
                </div>
                <p className="chat-item-preview">{chat.lastMessage || 'Няма съобщения'}</p>
                <small className="chat-item-time">
                  {chat.createdAt?.toDate().toLocaleString('bg-BG')}
                </small>
              </div>
            ))
          )}
        </div>

        {/* Chat Messages */}
        <div className="chat-conversation">
          {selectedChat ? (
            <>
              <div className="conversation-header">
                <h3>Разговор с {selectedChat.customerName}</h3>
              </div>

              <div className="conversation-messages">
                {messages.map((msg) => (
                  <div
                    key={msg.id}
                    className={`admin-message ${msg.sender === 'admin' ? 'admin-sent' : 'admin-received'}`}
                  >
                    <div className="admin-message-content">
                      <p>{msg.text}</p>
                      <span className="admin-message-time">
                        {msg.timestamp?.toDate().toLocaleTimeString('bg-BG', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                    </div>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>

              <form className="conversation-input" onSubmit={handleSendMessage}>
                <input
                  type="text"
                  placeholder="Напишете отговор..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                />
                <button type="submit">
                  <i className="fas fa-paper-plane"></i> Изпрати
                </button>
              </form>
            </>
          ) : (
            <div className="no-chat-selected">
              <i className="fas fa-comments" style={{ fontSize: '64px', color: '#ccc' }}></i>
              <p>Изберете чат за да видите съобщенията</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
